module.exports = __webpack_public_path__ + "img/sdg_es_(13).b2334c67.png";